<form [formGroup]="fG">
  <ejs-radiobutton [name]="name || fCN" [value]="tmpValue" [label]="placeholder" [cssClass]="cssClass + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? ' e-error' : '')" [checked]="checked()" (change)="valueChanged($event)" [disabled]="disabled"></ejs-radiobutton>
</form>
